import { FORMATION_PRESETS, normalizeScheme } from "@livcg/schema";
import { useEffect, useState } from "react";
import { cn } from "../../ui/index.js";

const CUSTOM = "__custom__";
const PRESETS: readonly string[] = FORMATION_PRESETS;
const FIELD =
  "h-8 w-full rounded-md border border-border bg-surface px-2 font-mono text-[12.5px] text-ink";

/** SKORE-style formation pick for one side, kept in lineup.schemes. If that
 *  side's lineup is on air the scheme swaps live. A scheme that is not in the
 *  list can be entered manually via "Boshqa…". */
export function SchemeField({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (scheme: string) => void;
}) {
  const isPreset = PRESETS.includes(value);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  // While not being edited, it follows the value coming from outside.
  useEffect(() => {
    if (!editing) setDraft(value);
  }, [value, editing]);
  const showInput = editing || !isPreset;
  const normalized = normalizeScheme(draft);
  const invalid = draft.trim() !== "" && normalized === null;

  const commit = () => {
    if (!normalized) return;
    setDraft(normalized);
    setEditing(false);
    if (normalized !== value) onChange(normalized);
  };

  return (
    <label className="flex flex-col gap-1">
      <span className="text-[10.5px] uppercase tracking-[0.08em] text-ink-faint">{label}</span>
      <select
        value={showInput ? CUSTOM : value}
        onChange={(e) => {
          if (e.target.value === CUSTOM) {
            setDraft(isPreset ? "" : value);
            setEditing(true);
          } else {
            setEditing(false);
            onChange(e.target.value);
          }
        }}
        className={FIELD}
      >
        {PRESETS.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
        <option value={CUSTOM}>{isPreset ? "Boshqa…" : `${value} (qo'lda)`}</option>
      </select>
      {showInput && (
        <>
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commit}
            onKeyDown={(e) => {
              if (e.key === "Enter") commit();
              if (e.key === "Escape") {
                setDraft(value);
                setEditing(false);
              }
            }}
            placeholder="masalan 4231"
            aria-invalid={invalid}
            className={cn(FIELD, invalid && "border-danger")}
          />
          <span className={cn("text-[10.5px]", invalid ? "text-danger-strong" : "text-ink-faint")}>
            {invalid
              ? "2–5 qator, har qatorda 1–5, jami 10 (darvozabonsiz)"
              : normalized && normalized !== draft
                ? `→ ${normalized} · Enter`
                : "Enter — saqlash"}
          </span>
        </>
      )}
    </label>
  );
}
